import { render } from "./AppMenu.vue?vue&type=template&id=b84275ac&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b84275ac"

export default script